var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Report',_vm._g(_vm._b({attrs:{"column-defs":_vm.columnDefs,"retrieve-action":"report/retrieveShifts","source":"shifts"}},'Report',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }